import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Header from '../Header';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(171, 171, 171, 0.1)',
    height: '100vh',
    margin: '.3rem 0 1rem 0',
  },
  title: { ...theme.title, fontSize: '30px', marginBottom: '1rem' },
  text: {
    margin: '15vh 1vh',
    textAlign: 'center',
  },
  label: {
    fontFamily: ['FuturaStdBook', 'sans-serif'].join(','),
    color: '#262957',
  },
}));
const Page404 = ({ label }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Header
        title={t('my_ticket')}
        actions={{
          prev: {
            label: t('cancel'),
            path: `/restaurant`,
            icon: 'return',
          },
        }}
      />
      <Grid container className={classes.root} justifyContent="center">
        <Grid item className={classes.text}>
          <Typography variant="h3" className={classes.title}>
            {t('oupss')}
          </Typography>
          <Typography variant="h6" className={`${classes.label}`}>
            {t(label)}
          </Typography>
          {/*  <Typography variant="h6" className={`${classes.label}`}>
          {t('error_apologize_for_inconvenience')}
        </Typography> */}
        </Grid>
      </Grid>
    </>
  );
};

Page404.propTypes = {
  label: PropTypes.string.isRequired,
};

export default Page404;
